package org.zq.astrock_ai.ui.research.gushi.data

import kotlinx.serialization.Serializable
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.zq.astrock_ai.storage.ResearchKvStorage
import org.zq.astrock_ai.ui.research.gushi.model.ChatMessage

@Serializable
private data class ChatHistoryPayload(
    val messages: List<ChatMessageDto> = emptyList(),
)

@Serializable
private data class ChatMessageDto(
    val isUser: Boolean,
    val text: String,
    val time: String,
)

/**
 * 按股票代码持久化右侧 AI 聊天（localStorage / 平台 KV）。
 */
object ChatHistoryStore {
    private const val MAX = 60
    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = true
    }

    fun load(code: String): List<ChatMessage> {
        val digits = code.filter { it.isDigit() }.takeLast(6)
        val raw = ResearchKvStorage.get(key(digits))
            ?: ResearchKvStorage.get("chat.$digits.v1")
            ?: return emptyList()
        // 新格式 JSON
        runCatching {
            json.decodeFromString<ChatHistoryPayload>(raw).messages.map {
                ChatMessage(isUser = it.isUser, text = it.text, time = it.time)
            }
        }.getOrNull()?.takeIf { it.isNotEmpty() }?.let { return it }

        // 兼容旧版 TSV
        return raw.lineSequence().mapNotNull { line ->
            val parts = line.split('\t')
            if (parts.size < 3) return@mapNotNull null
            ChatMessage(
                isUser = parts[0] == "1",
                text = parts[1].replace("\\n", "\n").replace("\\t", "\t"),
                time = parts[2],
            )
        }.toList()
    }

    fun save(code: String, messages: List<ChatMessage>) {
        val trimmed = messages
            .filterNot { it.text.isBlank() }
            .takeLast(MAX)
        if (trimmed.isEmpty()) return
        val payload = ChatHistoryPayload(
            messages = trimmed.map {
                ChatMessageDto(isUser = it.isUser, text = it.text, time = it.time)
            },
        )
        ResearchKvStorage.put(key(code), json.encodeToString(payload))
    }

    private fun key(code: String) = "chat.${code.filter { it.isDigit() }.takeLast(6)}.v2"
}
